import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";


export interface FAQProps {
    open :boolean,
    handleClose: ()=>void
}

const FAQDialog = ({open, handleClose}: FAQProps) =>  {
    
    return (<Dialog open={open} onClose={handleClose}>
        <DialogTitle>FAQ</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="h6">This is the developers attempt to answer the frequently asked questions of know your steam.</Typography>
                  <Typography variant={"body1"} color="secondary.contrastText">Who is the Bestest of boys? </Typography>
                  <Typography variant={"body2"}>Loki the Developers Dog</Typography>
                      <Typography variant={"body1"} color="secondary.contrastText">What is Steam? </Typography>
                  <Typography variant={"body2"}>Steam is created when boiling hot water... however in this context its a digital game store front</Typography>
                       <Typography variant={"body1"} color="secondary.contrastText">Are you affiliated with Steam?</Typography>
                  <Typography variant={"body2"}>Nope, Just a couple of Nerds who like to develop and play games</Typography>
                      <Typography variant={"body1"} color="secondary.contrastText">Where do i find my steam URL and what does it look like?</Typography>
                  <Typography variant={"body2"} >It will look like https://steamcommunity.com/profiles/*YourPersonalSteamIDHere* </Typography>
                  <Typography variant={"body2"}> 
                    On a desktop 
                    go to the steam application where you are signed in, 
                    Click on your profile name, The Steam URL will be displayed under the main banner at the top.
                    </Typography>
                    <Typography variant={"body2"}>
                    On a mobile
                    go to your steam app, tap on your profile picture at the top, tap view profile, edit profile, scroll down until you see the URL under the custom URL field.
                    </Typography>
                       <Typography variant={"body1"} color="secondary.contrastText">Are there any more game modes?</Typography>
                  <Typography variant={"body2"}>We are planning more game modes but we are a team of 2 nerds, so this will take a moment</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Okay, I got it</Button>
        </DialogActions>
      </Dialog>
      )
  }
      
export default FAQDialog